// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"_9QL0","icon":"_2_c4y"};